import type { SessionsViewState } from './SessionsViewState.types';

interface ResolveSessionsViewStateParams {
  isLoading: boolean;
  isError: boolean;
  rows: unknown[];
  hasSearch: boolean;
  onNewSession: () => void;
  onClearFilters: () => void;
}

/**
 * Resolves the current view state for the Sessions page based on data state.
 */
export function resolveSessionsViewState({
  isLoading,
  isError,
  rows,
  hasSearch,
  onNewSession,
  onClearFilters,
}: ResolveSessionsViewStateParams): SessionsViewState {
  if (isError) {
    return { type: 'error' };
  }

  if (!isLoading && rows.length === 0) {
    if (hasSearch) {
      return { type: 'no-results', onClear: onClearFilters };
    }
    return { type: 'empty', onAction: onNewSession };
  }

  return { type: 'data' };
}
